(function () {
  function normalize(value) {
    return String(value || '')
      .toLowerCase()
      .replace(/\s+/g, ' ')
      .trim();
  }

  function initBooking(root) {
    if (!root || root.dataset.hjBookingReady === 'true') return;
    root.dataset.hjBookingReady = 'true';

    var currency = root.getAttribute('data-currency') || '€';
    var percent = parseFloat(root.getAttribute('data-deposit-percent')) || 30;
    var bouquetPrice = parseFloat(String(root.getAttribute('data-bouquet-price') || '0').replace(',', '.')) || 0;
    var hideAppointoSelector = root.getAttribute('data-hide-appointo-variant-selector') === 'true';

    var selectedSession = null;
    var selectedTitle = '';
    var selectedVariantId = '';
    var selectedFullPrice = 0;
    var selectedDeposit = 0;
    var checkoutInProgress = false;
    var cartBaseline = null;
    var cartMonitor = null;

    var form = root.querySelector('form[action*="/cart/add"]');
    var variantInput = root.querySelector('[data-hj-variant-input]');
    var sessionProperty = root.querySelector('[data-hj-property-session]');
    var totalProperty = root.querySelector('[data-hj-property-total]');
    var balanceProperty = root.querySelector('[data-hj-property-balance]');
    var sessionFieldGroups = root.querySelectorAll('[data-hj-session-fields]');
    var bouquetInput = root.querySelector('[data-hj-bouquet]');
    var extraRow = root.querySelector('[data-hj-extra-row]');
    var reservePanel = root.querySelector('[data-hj-reserve-panel]');
    var appointoWrapper = root.querySelector('[data-hj-appointo-wrapper]');
    var titleEl = root.querySelector('[data-hj-summary-title]');
    var totalEl = root.querySelector('[data-hj-summary-total]');
    var depositEl = root.querySelector('[data-hj-summary-deposit]');
    var balanceEl = root.querySelector('[data-hj-summary-balance]');
    var calendarTitleEl = root.querySelector('[data-hj-calendar-session]');
    var calendarDepositEl = root.querySelector('[data-hj-calendar-deposit]');
    var saveTimer = null;

    var firstLocation = root.querySelector('select[name="properties[First preferred location]"]');
    var secondLocation = root.querySelector('select[name="properties[Second preferred location]"]');

    var knownSessionTitles = Array.prototype.map.call(root.querySelectorAll('.hj-session'), function (card) {
      return normalize(card.getAttribute('data-title'));
    });

    var bookingVariantIds = Array.prototype.map.call(root.querySelectorAll('.hj-session[data-variant-id]'), function (card) {
      return String(card.getAttribute('data-variant-id') || '');
    }).filter(Boolean);

    function money(value) {
      var rounded = Math.round((Number(value || 0) + Number.EPSILON) * 100) / 100;
      var decimals = Math.abs(rounded - Math.round(rounded)) > 0.001 ? 2 : 0;
      return currency + ' ' + rounded.toFixed(decimals);
    }

    function currentBouquetPrice() {
      return bouquetInput && bouquetInput.checked ? bouquetPrice : 0;
    }

    function updateSummary() {
      if (!selectedSession) return;
      var extra = currentBouquetPrice();
      var balance = Math.max(0, selectedFullPrice - selectedDeposit) + extra;

      if (titleEl) titleEl.textContent = selectedTitle;
      if (totalEl) totalEl.textContent = money(selectedFullPrice);
      if (depositEl) depositEl.textContent = money(selectedDeposit);
      if (balanceEl) balanceEl.textContent = money(balance);
      if (calendarTitleEl) calendarTitleEl.textContent = selectedTitle;
      if (calendarDepositEl) calendarDepositEl.textContent = money(selectedDeposit);
      if (extraRow) extraRow.hidden = extra <= 0;
      if (sessionProperty) sessionProperty.value = selectedTitle;
      if (totalProperty) totalProperty.value = money(selectedFullPrice);
      if (balanceProperty) balanceProperty.value = money(balance);
    }

    function findAppointoVariantSelect() {
      if (!appointoWrapper) return null;
      var selects = appointoWrapper.querySelectorAll('select');
      var best = null;
      var bestScore = 0;

      Array.prototype.forEach.call(selects, function (select) {
        var score = 0;
        Array.prototype.forEach.call(select.options || [], function (option) {
          var text = normalize(option.textContent);
          if (knownSessionTitles.indexOf(text) !== -1) score += 1;
        });
        if (score > bestScore) {
          bestScore = score;
          best = select;
        }
      });

      return bestScore >= 2 ? best : null;
    }

    function maybeHideAppointoSelector(select) {
      if (!hideAppointoSelector || !select || select.dataset.hjHiddenSelector === 'true') return;
      select.dataset.hjHiddenSelector = 'true';
      select.classList.add('hj-booking__appointo-variant-select--hidden');

      window.requestAnimationFrame(function () {
        var parent = select.parentElement;
        if (!parent) return;
        var rect = parent.getBoundingClientRect();
        if (rect.height > 0 && rect.height <= 120 && rect.width <= 760 && parent.querySelectorAll('select').length === 1) {
          parent.classList.add('hj-booking__appointo-variant-control--hidden');
        }
      });
    }

    function syncAppointoVariant() {
      if (!selectedTitle) return;
      var select = findAppointoVariantSelect();
      if (!select) return;

      var target = null;
      Array.prototype.forEach.call(select.options || [], function (option) {
        if (target) return;
        var optionText = normalize(option.textContent);
        var optionValue = String(option.value || '');
        if (optionText === normalize(selectedTitle) || (selectedVariantId && optionValue === String(selectedVariantId))) {
          target = option;
        }
      });

      if (target && select.value !== target.value) {
        select.value = target.value;
        select.dispatchEvent(new Event('input', { bubbles: true }));
        select.dispatchEvent(new Event('change', { bubbles: true }));
      }

      maybeHideAppointoSelector(select);
    }

    function updateSessionFields(number) {
      Array.prototype.forEach.call(sessionFieldGroups, function (group) {
        var active = String(group.getAttribute('data-hj-session-fields')) === String(number);
        group.hidden = !active;
        Array.prototype.forEach.call(group.querySelectorAll('input, select, textarea'), function (field) {
          field.disabled = !active;
        });
      });
      syncSignatureLocations();
    }

    function syncSignatureLocations() {
      if (!firstLocation || !secondLocation) return;

      var firstValue = firstLocation.value || '';
      Array.prototype.forEach.call(secondLocation.options || [], function (option) {
        if (!option.value) {
          option.disabled = false;
          return;
        }
        option.disabled = !!firstValue && option.value === firstValue;
      });

      if (firstValue && secondLocation.value === firstValue) {
        secondLocation.value = '';
      }

      if (secondLocation.value && firstValue && secondLocation.value === firstValue) {
        secondLocation.setCustomValidity('Please choose a different second location.');
      } else {
        secondLocation.setCustomValidity('');
      }
    }

    function updateVariantUrl(variantId) {
      if (!variantId || !window.history || !window.URL) return;
      try {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variantId);
        window.history.replaceState({}, '', url.pathname + url.search + url.hash);
      } catch (error) {
        // Non-critical enhancement only.
      }
    }

    function collectLineProperties() {
      var properties = {};
      if (!form) return properties;

      properties['Session'] = selectedTitle || '';
      properties['Full session price'] = money(selectedFullPrice);
      properties['Deposit charged today'] = money(selectedDeposit);
      properties['Balance due on the day'] = money(Math.max(0, selectedFullPrice - selectedDeposit) + currentBouquetPrice());

      var fields = form.querySelectorAll('input[name^="properties["], select[name^="properties["], textarea[name^="properties["]');
      Array.prototype.forEach.call(fields, function (field) {
        if (field.disabled) return;
        var match = String(field.name || '').match(/^properties\[(.+)\]$/);
        if (!match) return;
        var key = match[1];
        var value = '';
        if (field.type === 'checkbox') {
          value = field.checked ? field.value : 'No';
        } else {
          value = field.value || '';
        }
        if (key && value) properties[key] = value;
      });

      return properties;
    }

    function collectCartAttributes() {
      var properties = collectLineProperties();
      var attributes = {};
      Object.keys(properties).forEach(function (key) {
        attributes[key] = properties[key];
      });
      return attributes;
    }

    function shopifyRoot() {
      return window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/';
    }

    function fetchCart() {
      return fetch(shopifyRoot() + 'cart.js', {
        method: 'GET',
        headers: { 'Accept': 'application/json' },
        credentials: 'same-origin',
        cache: 'no-store'
      }).then(function (response) {
        if (!response.ok) throw new Error('Could not read cart');
        return response.json();
      });
    }

    function saveCartAttributes() {
      if (!window.fetch) return Promise.resolve();
      return fetch(shopifyRoot() + 'cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        credentials: 'same-origin',
        body: JSON.stringify({ attributes: collectCartAttributes() })
      }).catch(function () {
        // Line item properties are the main source of truth; cart attributes are a backup.
      });
    }

    function queueSaveCartAttributes() {
      window.clearTimeout(saveTimer);
      saveTimer = window.setTimeout(saveCartAttributes, 350);
    }

    function findAddedBookingItem(beforeCart, afterCart) {
      var beforeMap = {};
      (beforeCart.items || []).forEach(function (item) {
        beforeMap[item.key] = item.quantity;
      });

      var changed = (afterCart.items || []).filter(function (item) {
        var oldQty = beforeMap[item.key] || 0;
        return bookingVariantIds.indexOf(String(item.variant_id)) !== -1 && item.quantity > oldQty;
      });

      if (changed.length) return changed[changed.length - 1];

      var newKey = (afterCart.items || []).filter(function (item) {
        return bookingVariantIds.indexOf(String(item.variant_id)) !== -1 && !Object.prototype.hasOwnProperty.call(beforeMap, item.key);
      });
      if (newKey.length) return newKey[newKey.length - 1];

      return null;
    }

    function updateLineItemProperties(item) {
      if (!item || !item.key) return Promise.resolve();
      var merged = {};
      var existing = item.properties || {};
      Object.keys(existing).forEach(function (key) {
        merged[key] = existing[key];
      });
      var custom = collectLineProperties();
      Object.keys(custom).forEach(function (key) {
        merged[key] = custom[key];
      });

      return fetch(shopifyRoot() + 'cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        credentials: 'same-origin',
        body: JSON.stringify({
          id: item.key,
          quantity: item.quantity,
          properties: merged
        })
      }).then(function (response) {
        if (!response.ok) throw new Error('Could not save booking details');
        return response.json();
      });
    }

    function removeOlderBookingItems(cart, keepKey) {
      var oldItems = (cart.items || []).filter(function (item) {
        return item.key !== keepKey && bookingVariantIds.indexOf(String(item.variant_id)) !== -1;
      });

      var chain = Promise.resolve();
      oldItems.forEach(function (item) {
        chain = chain.then(function () {
          return fetch(shopifyRoot() + 'cart/change.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json'
            },
            credentials: 'same-origin',
            body: JSON.stringify({ id: item.key, quantity: 0 })
          });
        });
      });
      return chain;
    }

    function restoreAddedBookingItem(beforeCart, addedItem) {
      if (!addedItem || !addedItem.key) return Promise.resolve();
      var previousQuantity = 0;
      (beforeCart.items || []).forEach(function (item) {
        if (item.key === addedItem.key) previousQuantity = item.quantity;
      });

      return fetch(shopifyRoot() + 'cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        credentials: 'same-origin',
        body: JSON.stringify({ id: addedItem.key, quantity: previousQuantity })
      }).then(function () {
        return fetchCart();
      });
    }

    function handleBookingAdded(beforeCart, afterCart, addedItem) {
      if (checkoutInProgress) return;

      syncSignatureLocations();
      if (form && !form.checkValidity()) {
        checkoutInProgress = true;
        restoreAddedBookingItem(beforeCart, addedItem).then(function (freshCart) {
          cartBaseline = freshCart;
          checkoutInProgress = false;
          form.reportValidity();
          var invalidField = form.querySelector(':invalid');
          if (invalidField && invalidField.scrollIntoView) {
            invalidField.scrollIntoView({ behavior: 'smooth', block: 'center' });
          }
        }).catch(function () {
          checkoutInProgress = false;
        });
        return;
      }

      checkoutInProgress = true;
      updateLineItemProperties(addedItem)
        .then(function () { return fetchCart(); })
        .then(function (freshCart) { return removeOlderBookingItems(freshCart, addedItem.key); })
        .then(function () { return saveCartAttributes(); })
        .then(function () {
          window.location.href = shopifyRoot() + 'checkout';
        })
        .catch(function () {
          checkoutInProgress = false;
          cartBaseline = afterCart;
        });
    }

    function startCartMonitor() {
      if (!window.fetch || !bookingVariantIds.length) return;
      fetchCart().then(function (cart) {
        cartBaseline = cart;
        cartMonitor = window.setInterval(function () {
          if (checkoutInProgress || document.visibilityState === 'hidden' || !cartBaseline) return;
          fetchCart().then(function (afterCart) {
            var added = findAddedBookingItem(cartBaseline, afterCart);
            if (added) {
              handleBookingAdded(cartBaseline, afterCart, added);
            } else {
              cartBaseline = afterCart;
            }
          }).catch(function () {
            // Keep the booking page usable even if a background cart check fails.
          });
        }, 900);
      }).catch(function () {
        // No redirect helper; Appointo remains usable by itself.
      });
    }

    function selectSession(number, scrollToFlow) {
      var card = root.querySelector('.hj-session[data-session="' + number + '"]');
      if (!card) return;

      selectedSession = String(number);
      selectedTitle = card.getAttribute('data-title') || '';
      selectedVariantId = card.getAttribute('data-variant-id') || '';
      selectedFullPrice = parseFloat(String(card.getAttribute('data-price') || '0').replace(',', '.')) || 0;

      var depositCents = parseInt(card.getAttribute('data-deposit-cents') || '0', 10) || 0;
      selectedDeposit = depositCents > 0 ? depositCents / 100 : selectedFullPrice * percent / 100;

      Array.prototype.forEach.call(root.querySelectorAll('.hj-session'), function (item) {
        item.classList.toggle('is-selected', item === card);
      });

      if (variantInput && selectedVariantId) {
        variantInput.value = selectedVariantId;
        variantInput.dispatchEvent(new Event('input', { bubbles: true }));
        variantInput.dispatchEvent(new Event('change', { bubbles: true }));
      }

      updateSessionFields(number);
      updateSummary();
      updateVariantUrl(selectedVariantId);
      queueSaveCartAttributes();

      var attempts = 0;
      var syncTimer = window.setInterval(function () {
        syncAppointoVariant();
        attempts += 1;
        if (attempts >= 20) window.clearInterval(syncTimer);
      }, 300);

      if (scrollToFlow && reservePanel) {
        window.setTimeout(function () {
          reservePanel.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }, 80);
      }
    }

    Array.prototype.forEach.call(root.querySelectorAll('[data-hj-select-session]'), function (button) {
      button.addEventListener('click', function () {
        selectSession(button.getAttribute('data-hj-select-session'), true);
      });
    });

    if (firstLocation) firstLocation.addEventListener('change', syncSignatureLocations);
    if (secondLocation) secondLocation.addEventListener('change', syncSignatureLocations);

    if (form) {
      Array.prototype.forEach.call(form.querySelectorAll('input, select, textarea'), function (field) {
        if (field.hasAttribute('data-hj-variant-input')) return;
        field.addEventListener('change', function () {
          updateSummary();
          queueSaveCartAttributes();
        });
        if (field.tagName === 'INPUT' || field.tagName === 'TEXTAREA') {
          field.addEventListener('input', queueSaveCartAttributes);
        }
      });
    }

    if (bouquetInput) {
      bouquetInput.addEventListener('change', function () {
        updateSummary();
        queueSaveCartAttributes();
      });
    }

    selectSession('1', false);
    syncSignatureLocations();
    startCartMonitor();
  }

  function boot() {
    Array.prototype.forEach.call(document.querySelectorAll('.hj-booking'), initBooking);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target && event.target.querySelector ? event.target.querySelector('.hj-booking') : null;
    if (root) initBooking(root);
  });
})();
